import { StockStatus as Status } from '../../../@types/stock.enum';
import { formatDeliveryDays } from '../../utils/stockStatus';

export const getHeading = (status?: Status, store?: string) => {
  if (status === undefined || !store) {
    return '';
  }
  switch (status) {
    case Status.InCentralStoreStock:
    case Status.Incoming:
    case Status.IncomingToCentralStorage:
    case Status.Orderable:
      return 'Beställningsvara hos ';

    case Status.InStock:
      return 'Finns i lager hos ';

    case Status.Unavailable:
      return 'Slut hos ';

    case Status.NotFound:
    default:
      return 'Lagerinformation saknas hos ';
  }
};

export const getText = (itemStatus?: {
  status?: Status;
  date?: string;
  deliveryDays?: number;
  availableItems?: number;
}) => {
  if (!itemStatus) {
    return '';
  }
  switch (itemStatus.status) {
    case Status.Incoming:
      return itemStatus.date && `Åter i butik ${itemStatus.date.substr(0, 10)}`;

    case Status.InCentralStoreStock:
    case Status.IncomingToCentralStorage:
    case Status.Orderable:
      return (itemStatus.deliveryDays && formatDeliveryDays(itemStatus.deliveryDays)) || '';

    case Status.InStock:
      return `${itemStatus.availableItems} st`;

    case Status.Unavailable:
      return '';

    case Status.NotFound:
    default:
      return 'Vänligen kontakta butiken för mer information. ';
  }
};
